import { convertKebabToCamel } from "./convertKebabToCamel";
export function getAttributesCamelCase(element) {
    if (typeof element === "undefined") {
        return {};
    }
    const nodeMap = element.attributes;
    const length = nodeMap.length;
    // @ts-expect-error Check for typing
    return Object.keys(nodeMap).reduce((props, current) => {
        try {
            const numCurrent = parseInt(current, 10);
            if (numCurrent < length) {
                // @ts-expected-error Check for typing
                const property = nodeMap[Number(current)];
                const camelCaseProp = convertKebabToCamel(property.name);
                return {
                    ...props,
                    [camelCaseProp]: property.value
                };
            }
        }
        catch {
            // nothing
        }
    }, {});
}
//# sourceMappingURL=getAttributesCamelCase.js.map
